import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import alert from './alert'
import alerts from './alerts'
import analysis from './analysis'
import attributes from './attributes'
import businessDay from './businessDay'
import businesshour from './businesshour'
import courses from './courses'
import customer from './customer'
import customers from './customers'
import gnavi from './gnavi'
import holidays from './holidays'
import imageMemos from './imageMemos'
import layouts from './layouts'
import login from './login'
import mailConversion from './mailConversion'
import mails from './mails'
import medias from './medias'
import memo from './memo'
import orders from './orders'
import reception from './reception'
import reservation from './reservation'
import reserves from './reserves'
import resraku from './resraku'
import staffs from './staffs'
import stores from './stores'
import syncGnavis from './syncGnavis'
import storetransfer from './storetransfer'
import tables from './tables'
import tags from './tags'
import token from './token'
import users from './users'
import user from './user'
import init from './home/init'
import ivr from './ivr'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    alert,
    alerts, // TODO alert と統合したい
    analysis,
    attributes,
    businessDay,
    businesshour,
    courses,
    customer, // TODO customers に統合したい
    customers,
    gnavi,
    holidays,
    imageMemos,
    layouts,
    mailConversion,
    mails,
    medias,
    memo,
    orders,
    reception,
    reservation,
    reserves,
    resraku,
    staffs,
    stores,
    syncGnavis,
    storetransfer,
    tables,
    tags,
    token,
    users,
    user,
    login,
    init,
    ivr,
  },
})
